import React from 'react';

const ErrorPage = ({ message = "Something went wrong. Please try again." }) => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>🚫 Error</h2>
      <p style={styles.message}>{message}</p>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '70vh', 
    color: '#b00020',
    textAlign: 'center',
    padding: '20px',
  },
  heading: {
    fontSize: '24px',
    marginBottom: '10px',
  },
  message: {
    fontSize: '16px',
  },
};


export default ErrorPage;
